import { create } from 'zustand';
import { Test } from '@/types/evals-types';

interface EvaluationStore {
  testsById: Record<string, Test>;
  setTests: (tests: Test[]) => void;
  upsertTest: (test: Test) => void;
  removeTest: (testId: string) => void;
  clear: () => void;
}

export const useEvaluationStore = create<EvaluationStore>((set) => ({
  testsById: {},
  setTests: (tests: Test[]) =>
    set(() => {
      const newTestByIdMap: Record<string, Test> = {};
      for (const test of tests || []) {
        if (test.id) newTestByIdMap[test.id] = test;
      }
      return { testsById: newTestByIdMap };
    }),
  upsertTest: (test: Test) =>
    set((state) => {
      const updatedTestsById: Record<string, Test> = { ...state.testsById };
      if (test?.id) {
        updatedTestsById[test.id] = test;
      }
      return { testsById: updatedTestsById };
    }),
  removeTest: (testId: string) =>
    set((state) => {
      const updatedTestsById = { ...state.testsById };
      delete updatedTestsById[testId];
      return { testsById: updatedTestsById };
    }),
  clear: () => set({ testsById: {} }),
}));
